export type InactiveCaseStatusesType = Extract<
  CaseStatus,
  'COMPLETE' | 'NOT_PROCEEDING' | 'REFERRED' | 'IMPORTED_COMPLETE'
>

export const inactiveCaseStatuses: CaseStatus[] = ['COMPLETE', 'NOT_PROCEEDING', 'REFERRED', 'IMPORTED_COMPLETE']
